import React from "react";
import { ProducerPreviewReportPlaybackTimeCellTemplate } from "themes/common/components/producer";

function ProducerPreviewReportPlaybackTimeCell(props) {
    return <ProducerPreviewReportPlaybackTimeCellTemplate {...props} />;
}

export default ProducerPreviewReportPlaybackTimeCell;
